var map = {
	"./sba.dark.blue.scss": [
		1622,
		622
	],
	"./sba.dark.green.scss": [
		7985,
		985
	],
	"./sba.dark.orange.scss": [
		5848,
		848
	],
	"./sba.dark.purple.scss": [
		7720,
		720
	],
	"./sba.dark.red.scss": [
		6253,
		253
	],
	"./sba.light.blue.scss": [
		5678,
		678
	],
	"./sba.light.green.scss": [
		4057,
		438
	],
	"./sba.light.orange.scss": [
		1040,
		40
	],
	"./sba.light.purple.scss": [
		6032,
		32
	],
	"./sba.light.red.scss": [
		533,
		533
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8742;
module.exports = webpackAsyncContext;